'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _require = require('./atom'),
    Atom = _require.Atom,
    isAtom = _require.isAtom;

var _require2 = require('./lifetime'),
    deinitDiff = _require2.deinitDiff,
    isOwner = _require2.isOwner;

/**
 * Interfaces
 */

exports.isAgent = isAgent;
function isAgent(value) {
  return isAtom(value) && isOwner(value);
}

/**
 * Classes
 */

// WTB better name

var Agent = function (_Atom) {
  _inherits(Agent, _Atom);

  function Agent() {
    _classCallCheck(this, Agent);

    return _possibleConstructorReturn(this, _Atom.apply(this, arguments));
  }

  Agent.prototype.reset = function reset(next) {
    var prev = this.value;
    try {
      _Atom.prototype.reset.call(this, next);
    } finally {
      deinitDiff(prev, next);
    }
  };

  Agent.prototype.unwrap = function unwrap() {
    var value = this.value;

    this.value = undefined;
    try {
      this.trigger(this);
      return value;
    } catch (err) {
      deinitDiff(value);
      throw err;
    }
  };

  Agent.prototype.deinit = function deinit() {
    try {
      _Atom.prototype.deinit.call(this);
    } finally {
      this.reset(undefined);
    }
  };

  return Agent;
}(Atom);

exports.Agent = Agent;


//////////////////
// WEBPACK FOOTER
// ./~/espo/dist/agent.js
// module id = 2047
// module chunks = 118